import {
  Fragment,
  lazy,
  type ComponentProps,
  type ComponentType,
  type ReactNode,
} from 'react';

import { DesktopOnly } from '#/components/Breakpoint/DesktopOnly';
import { ClientOnly } from '#/containers/ClientOnly';

export function clientOnlyLazy<
  // oxlint-disable-next-line typescript/no-explicit-any
  T extends ComponentType<any>,
>(
  load: () => Promise<{ default: T }>,
  options?: { placeholder?: ReactNode; desktopOnly?: boolean },
) {
  const LazyComponent = lazy(load);

  function ClientOnlyLazy(props: ComponentProps<T>) {
    const Wrapper = options?.desktopOnly ? DesktopOnly : Fragment;

    return (
      <ClientOnly placeholder={options?.placeholder}>
        <Wrapper>
          <LazyComponent
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
        </Wrapper>
      </ClientOnly>
    );
  }

  return ClientOnlyLazy;
}
